import { Box } from "@shared/primitive-components"
import { root } from "./detailListStyles"

interface Props {
  children: React.ReactNode
}

const Root: React.FC<Props> = ({ children }: Props) => (
  <Box as="ul" css={root}>
    {children}
  </Box>
)

Root.displayName = `DetailList.Root`

export { Root }
